<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="activeView === 'actionRequired' ? 'Action Required' : 'Recent Orders'"
    [icon]="'history'"
>
    <div class="content">

        <div class="filters">
            <mat-form-field class="date-range">
                <mat-label>Date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input (dateChange)="updateFilter()" [(ngModel)]="filter.startDate" matStartDate
                           placeholder="Start date">
                    <input (dateChange)="updateFilter()" [(ngModel)]="filter.endDate" matEndDate placeholder="End date">
                </mat-date-range-input>
                <span matIconSuffix class="clear-button">
                    <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                    <button mat-icon-button (click)="clearDate()"
                            [disabled]="!filter.startDate && !filter.endDate">
                        <mat-icon>clear</mat-icon>
                    </button>
                </span>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field class="status">
                <mat-label>Status</mat-label>
                <mat-select placeholder="All Status" [(ngModel)]="filter.statusValues" (selectionChange)="updateFilter()" multiple>
                    @for (statusValue of allStatusValues; track statusValue) {
                        <mat-option [value]="statusValue">{{ statusValue }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field  class="module">
                <mat-label>Module</mat-label>
                <mat-select [(ngModel)]="filter.module" (selectionChange)="updateFilter()">
                    <mat-option [value]="undefined">All</mat-option>
                    @for (designerModule of allDesignerModules; track designerModule) {
                        <mat-option [value]="designerModule">{{ designerModule }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <table mat-table [matSortActive]="'dateCreatedUtc'" [matSortDirection]="filter.dateOrdering" matSort (matSortChange)="updateSort($event)" class="orders-table mat-elevation-z4" [dataSource]="lines">
            <!-- Store Order ID Column -->
            <ng-container matColumnDef="storeOrderId">
                <mat-header-cell *matHeaderCellDef>Store Order Id</mat-header-cell>
                <mat-cell *matCellDef="let line">
                    <a [routerLink]="'/stores/' + $orderLine(line).store.id + '/orders/' + $orderLine(line).order.storeOrderId">
                        <span class="order-id">{{ $orderLine(line).order.storeOrderId }} </span> <span class="order-line-id">(line {{ $orderLine(line).storeOrderLineNumber }})</span>
                    </a>
                </mat-cell>
            </ng-container>
            <!-- Date Created Column -->
            <ng-container matColumnDef="dateCreatedUtc">
                <mat-header-cell *matHeaderCellDef [disableClear]="true" mat-sort-header>Date Created</mat-header-cell>
                <mat-cell *matCellDef="let line">
                    <div>
                        <div class="text-truncate">
                            {{ $orderLine(line).dateCreatedUtc | date: "mediumDate" }}
                            {{ $orderLine(line).dateCreatedUtc | date: "HH:mm" }}

                        </div>
                        <div class="text-truncate">
                            <span>({{ $orderLine(line).dateCreatedUtc | fromNow }})</span>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>
            <!-- Date Created Column -->
            <ng-container matColumnDef="shortDate">
                <mat-header-cell *matHeaderCellDef>Date Created</mat-header-cell>
                <mat-cell *matCellDef="let line">
                    <p class="text-truncate">
                        <span>{{ $orderLine(line).dateCreatedUtc | fromNow }}</span>
                    </p>
                </mat-cell>
            </ng-container>
            <!-- Module Column -->
            <ng-container matColumnDef="module">
                <mat-header-cell *matHeaderCellDef>Module</mat-header-cell>
                <mat-cell *matCellDef="let line">
                    <p class="text-truncate">
                        <span>{{ $orderLine(line).module }}</span>
                    </p>
                </mat-cell>
            </ng-container>
            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                <mat-cell *matCellDef="let line">
                    <admin-line-status
                        [status]="$orderLine(line).status.value"
                        [flags]="$orderLine(line).status.flags"
                    ></admin-line-status>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row
                *matRowDef="let line; columns: displayedColumns"
                class="order"
            >
            </mat-row>
        </table>

        <div class="paginator">
            <mat-form-field class="result-per-page">
                <mat-label>Result per page</mat-label>
                <mat-select [(ngModel)]="resultPerPage" (selectionChange)="updateFilter()">
                    <mat-option [value]="10">10</mat-option>
                    <mat-option [value]="20">20</mat-option>
                    <mat-option [value]="50">50</mat-option>
                    <mat-option [value]="200">200</mat-option>
                </mat-select>
            </mat-form-field>
            <span>Page: {{ page + 1 }}</span>
            <button mat-icon-button [disabled]="page === 0" (click)="loadPage(0)">
                <mat-icon>first_page</mat-icon>
            </button>
            <button mat-icon-button [disabled]="page === 0" (click)="loadPage(page - 1)">
                <mat-icon>navigate_before</mat-icon>
            </button>
            <button mat-icon-button [disabled]="!hasNextPage" (click)="loadPage(page + 1)">
                <mat-icon>navigate_next</mat-icon>
            </button>
        </div>

    </div>
</admin-page-simple-content>
